import React from 'react';
import { Link } from 'react-router-dom';
import { tutorialAPI } from '../services/api';
import useApi from '../hooks/useApi';

const TutorialList = () => {
    const { data: tutorials, loading, error } = useApi(tutorialAPI.getTutorials);

    if (loading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    Error loading tutorials: {error.message}
                </div>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h1>Available Tutorials</h1>
            <div className="row mt-4">
                {tutorials?.map((tutorial) => (
                    <div key={tutorial.id} className="col-md-4 mb-4">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{tutorial.title}</h5>
                                <p className="card-text">{tutorial.description}</p>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="badge bg-primary">
                                        {tutorial.difficulty}
                                    </span>
                                    <Link to={`/tutorial/${tutorial.id}`} className="btn btn-primary">
                                        Start Tutorial
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TutorialList; 